import { all, takeEvery } from 'redux-saga/effects';
import { getAsyncSagas } from 'react-async-client';
import { toast } from 'react-toastify';

import appRun from './appRun';
import login from './login';
import error from './error';

import { SEND_FEEDBACK, POST_PROJECT, POST_APPLICATION } from 'constants/actionTypes';
import { notification } from 'antd';
import { toSuccess, toError } from 'react-async-client';


export default function* rootSaga() {
    yield all([
        ...getAsyncSagas(),
        login(),
        appRun(),
        error(),
        takeEvery([toError(SEND_FEEDBACK)], function () {
            notification.open({
                message: 'Обращение не было отправлено, попробуйте позже.',
                duration: 2
            });
        }),
        takeEvery([toSuccess(SEND_FEEDBACK)], function () {
            notification.open({
                message: 'Обращение отправлено.',
                duration: 2
            });
        }),
        takeEvery([toSuccess(POST_PROJECT)], function(action) {
            toast(`Вы создали проект ${action.requestAction.payload.name}`);
        }),
        takeEvery([toSuccess(POST_APPLICATION)], function(action) {
            toast(`Вы создали звявку ${action.requestAction.payload.name}`);
        })
    ]);
}



// WEBPACK FOOTER //
// ./src/sagas/rootSaga.js